'use es6';

import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { getCanUsePartitioning, getIsUserSuperAdmin } from 'FileManagerCore/selectors/Auth';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { connect } from 'react-redux';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import { openModal } from '../actions/Actions';
import * as ModalTypes from '../enums/ModalTypes';
import getIsSystemFolder from 'FileManagerCore/utils/getIsSystemFolder';
import { ObjectCategory } from 'FileManagerCore/Constants';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const getTooltip = (isReadOnly, isSystemFolder) => {
  if (isReadOnly) {
    return ScopedFeatureTooltip;
  }
  return ({
    children
  }) => /*#__PURE__*/_jsx(UITooltip, {
    "data-test-id": "access-tooltip",
    disabled: !isSystemFolder,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "FileManagerDashboard.actions.cannotPartitionSystem"
    }),
    children: children
  });
};
const ManageAccessButton = ({
  canUsePartitioning,
  isReadOnly,
  dispatch,
  folder,
  isSuperAdmin
}) => {
  const isSystemFolder = getIsSystemFolder(folder);
  const TooltipComponent = getTooltip(isReadOnly, isSystemFolder);
  return canUsePartitioning && /*#__PURE__*/_jsx(TooltipComponent, {
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      disabled: isReadOnly || isSystemFolder,
      "data-test-id": "manage-access-action-button",
      onClick: () => dispatch(openModal(isSuperAdmin ? ModalTypes.PARTITION_FOLDER : ModalTypes.VIEW_FOLDER_ACCESS, {
        objectCategory: ObjectCategory.FOLDER,
        objectId: folder.get('id')
      })),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isSuperAdmin ? 'FileManagerDashboard.actions.partition' : 'FileManagerDashboard.actions.partitionView'
      })
    })
  });
};
const mapStateToProps = state => ({
  canUsePartitioning: getCanUsePartitioning(state),
  isReadOnly: getIsReadOnly(state),
  isSuperAdmin: getIsUserSuperAdmin(state)
});
ManageAccessButton.propTypes = {
  canUsePartitioning: PropTypes.bool.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  folder: PropTypes.instanceOf(Immutable.Map)
};
export default connect(mapStateToProps)(ManageAccessButton);